import { render, staticRenderFns } from "./CreateAttendanceKidCustomExcel.vue?vue&type=template&id=9daa3df4&scoped=true"
import script from "./CreateAttendanceKidCustomExcel.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceKidCustomExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daa3df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9daa3df4')) {
      api.createRecord('9daa3df4', component.options)
    } else {
      api.reload('9daa3df4', component.options)
    }
    module.hot.accept("./CreateAttendanceKidCustomExcel.vue?vue&type=template&id=9daa3df4&scoped=true", function () {
      api.rerender('9daa3df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateAttendanceKidCustomExcel.vue"
export default component.exports